import { NodeClass, WORKFLOW_TRIGGERS } from 'modules/workflows';
import {
  INDETERMINABLE_ORIGIN_TRIGGERS,
  UNFILTERABLE_TRIGGERS,
} from 'modules/workflows/utils/nodeUtils/fieldsMatchUtils/fieldMatchUtils.constants';
import { FIELDS_MATCH_RADIO_OPTIONS } from 'modules/workflowNodeEditors/components/YesNoSplitEditor';
import { StyledWarningBanner } from '../YesNoSplitEditor/YesNoSplitEditor.styled';

const UNMATCHED_EVENT_TEXT = 'This journey’s entry source doesn’t match the event selected below.';

export const FieldsMatchWarningBanner = ({
  startNodeClass,
  startNodeTriggersOnUnspecifiedCustomEvent,
}: {
  startNodeClass: NodeClass;
  startNodeTriggersOnUnspecifiedCustomEvent: boolean;
}) => {
  if (UNFILTERABLE_TRIGGERS.includes(startNodeClass)) {
    return (
      <StyledWarningBanner>
        {startNodeClass === WORKFLOW_TRIGGERS.FIELD_CHANGED
          ? UNMATCHED_EVENT_TEXT
          : 'This journey’s entry source is not an event.'}
        <br />
        Click <b>Update</b> to clear these split criteria and switch to filtering by{' '}
        <b>{FIELDS_MATCH_RADIO_OPTIONS[0].name}</b>.
      </StyledWarningBanner>
    );
  }
  if (INDETERMINABLE_ORIGIN_TRIGGERS.includes(startNodeClass)) {
    return (
      <StyledWarningBanner>
        This journey&apos;s entry source is <b>Other journey</b>. Please ensure that the linked
        journey&apos;s entry source is an event that corresponds to the criteria below.
      </StyledWarningBanner>
    );
  }
  // if Custom Event is selected but no particular custom event is selected in the start tile...
  if (startNodeTriggersOnUnspecifiedCustomEvent) {
    return (
      <StyledWarningBanner>
        This journey&apos;s entry source doesn&apos;t have the specific custom event selected.
        <br />
        Please select the custom event in the Start tile before setting up this Yes/no split.
      </StyledWarningBanner>
    );
  }
  return (
    <StyledWarningBanner>
      {UNMATCHED_EVENT_TEXT} Please select a new event.
      <br />
      Saving a tile without making any changes will <b>reset these fields</b>.
    </StyledWarningBanner>
  );
};
